import { Component } from '@angular/core';

@Component({
  selector: 'app-aqui-estaremos',
  templateUrl: './aqui-estaremos.component.html',
  styleUrl: './aqui-estaremos.component.scss'
})
export class AquiEstaremosComponent {

}
